<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card :header="cardTitle" v-if="promocao" class="card-edicao">
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Titulo" class="mt-3">
            <b-form-input v-model="tituloPromocao" />
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Descrição" class="mt-3">
            <b-form-input v-model="descricaoPromocao" />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Inicial" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datainicial"
              :language="ptBR"
              :format="customFormatter"
              :disabled="true"
              :disabledDates="disabledDatesStart"
              :key="disabledDatesStart != null"
              @selected="mudaDataInicial"
              v-if="datainicial != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Final" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="datafinal"
              :disabled="true"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesEnd"
              :key="disabledDatesEnd != null"
              @selected="mudaDataFinal"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col cols="12" lg="6" class="mt-3">
          <table>
            <tr>
              <td class="mw67">
                <c-switch
                  class="mx-1"
                  v-model="showText"
                  color="success"
                  checked.sync="showText"
                  variant="3d"
                  @change="onChangeShowText"
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Exibir Título e Descrição no App</strong>
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="danger" class="mt-3 botao" @click="goBack()"
            >Cancelar</b-button
          >
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 botao" @click="save()"
            >Salvar</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "editar-promocao",
  components: { Loading, Datepicker, moment, VueTimepicker, cSwitch },
  data: function () {
    return {
      isLoading: false,
      id: null,
      promocao: null,
      cardTitle: "",
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      datainicial: new Date(),
      datafinal: new Date(),
      showText: false,
      tituloPromocao: null,
      descricaoPromocao: null,
      idPromocao: null,
    };
  },
  methods: {
    limpaLocalStorage() {
      localStorage.removeItem("show-text");
    },
    onChangeShowText() {
      localStorage.setItem("show-text", this.showText);
    },
    goBack() {
      this.$router.go(-1);
    },
    async save() {
      this.isLoading = true;

      const url = `${config.default.servidor}/gerencial/promocao`;

      if (await this.verificaDataPromocao()) {
        if (
          moment(this.promocao.datainicial).isAfter(this.promocao.datafinal)
        ) {
          this.isLoading = false;
          await this.$alert("Datas inválidas", "Aviso", "warning");
        } else if (moment(this.promocao.datainicial).isAfter(Date.now())) {
          this.isLoading = false;
          await this.$alert("Datas inválidas", "Aviso", "warning");
        } else if (moment(Date.now()).isAfter(this.promocao.datafinal)) {
          this.isLoading = false;
          await this.$alert("Datas inválidas", "Aviso", "warning");
        } else {
          this.promocao.datainicial = moment(
            this.promocao.datainicial
          ).format();
          this.promocao.datafinal = moment(this.promocao.datafinal).format();

          console.info({
            promocao: this.idPromocao,
            titulo: this.tituloPromocao,
            descricao: this.descricaoPromocao,
            datainicial: this.datainicial,
            datafinal: this.datafinal,
            showText: this.showText ? true : false,
          });

          try {
            await axios({
              url,
              method: "post",
              data: {
                id: this.idPromocao,
                titulo: this.tituloPromocao,
                descricao: this.descricaoPromocao,
                datainicial: this.datainicial,
                datafinal: this.datafinal,
                showText: this.showText ? true : false,
              },
              headers: {
                authorization: `${config.default.authorizationBasic}`,
              },
            });

            this.isLoading = false;
            await this.$alert(
              "Promoção alterada com sucesso!",
              "Sucesso",
              "success"
            );
            this.$router.go(-1);
          } catch (error) {
            this.isLoading = false;
            await this.$alert("Falha ao alterar a promoção!", "Erro", "error");
            this.$router.go(-1);
          }
        }
      } else {
        this.isLoading = false;
        await this.$alert(
          "Data final maior que a data cadastrada no sistema",
          "Aviso",
          "warning"
        );
      }
    },

    async verificaDataPromocao() {
      const url = `${
        config.default.servidor
      }/gerencial/promocao/data/${localStorage.getItem("enterprise_id")}/${
        this.promocao.idlocal
      }/${moment(this.datafinal).format("YYYY-MM-DD")}`;

      try {
        await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        return true;
      } catch (error) {
        return false;
      }
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    mudaDataFinal(data) {
      if (data) {
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },
    mudaDataInicial(data) {
      if (data) {
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
      }
    },

    async getPromocoes() {
      const url = `${config.default.servidor}/gerencial/promocao/dados/${this.id}`;
      try {
        const response = await axios({
          url: url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        this.promocao = response.data.data;

        (this.idPromocao = this.promocao.id),
          (this.datainicial = new Date(this.promocao.datainicial));
        this.datafinal = new Date(this.promocao.datafinal);
        this.showText = this.promocao.showText;
        this.tituloPromocao = this.promocao.titulo;
        this.descricaoPromocao = this.promocao.descricao;

        // Desabilita as datas iniciais que sejam menores do que hoje
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(moment(this.datafinal));

        // Desabilita as datas finais que sejam menores ou iguais a data inicial
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(this.datainicial);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        await this.$alert(`Erro: ${error}`, "Aviso", "error");
        this.$router.go(-1);
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    this.id = this.$route.params.id;
    this.cardTitle = `Promoção`;
    if (this.id == null) {
      await this.$alert(
        "Não encontramos a promoção indicada!",
        "Aviso",
        "warning"
      );
      this.$router.go(-1);
    } else {
      await this.getPromocoes();
    }
  },
};
</script>
<style>
.card-edicao > .card-body {
  padding-top: 0.25rem !important;
}
.date-input > .form-control > div > input {
  width: 100%;
  height: 100%;
  border: none;
  color: #5c6873;
}
.botao {
  width: 100% !important;
}
.input-group-text {
  width: 100px !important;
}
.form-control > input {
  width: calc(100% - 20px) !important;
  height: 100% !important;
  border: none !important;
  padding: 0 !important;
  color: #5c6873;
}
</style>

